module.exports = __webpack_public_path__ + "static/media/YB5M15_2.077e6600.jpg";